import {configureStore} from '@reduxjs/toolkit'
import {api} from "./middleware/api";
import documents from "./documents"
import serial_numbers from "./serial_numbers"
import login from "./logIn"
import orders from "./orders"


export default configureStore({
    reducer: {
        documents, login, serial_numbers, orders
    },
    middleware: [
        api,
    ]
})